import React from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import VerseMarquee from "../components/site/VerseMarquee";
import ApplySection from "../components/site/ApplySection";
import CoachWord from "../components/site/CoachWord";
import Pillars from "../components/site/Pillars";
import Brotherhood from "../components/site/Brotherhood";
import HowItWorks from "../components/site/HowItWorks";
import CoachBio from "../components/site/CoachBio";
import FAQ from "../components/site/FAQ";
import ForgedPlate from "../components/site/ForgedPlate";
import FinalCTA from "../components/site/FinalCTA";
import Footer from "../components/site/Footer";
import CursorSpark from "../components/site/CursorSpark";
import ScriptureBanner from "../components/site/ScriptureBanner";
import ForgeInterlude from "../components/site/ForgeInterlude";
import GalleryStrip from "../components/site/GalleryStrip";

export default function Home() {
  return (
    <div className="relative">
      <CursorSpark />
      <Navbar />
      <main>
        <Hero />
        <ApplySection />
        <VerseMarquee />
        <CoachWord />
        <ScriptureBanner />
        <Pillars />
        <ForgeInterlude />
        <Brotherhood />
        <HowItWorks />
        <CoachBio />
        <GalleryStrip />
        <FAQ />
        <ForgedPlate />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
